import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { Row, Col, Input, Label, Form, FormGroup } from 'reactstrap';
import { toast } from 'react-toastify';
import { Btn } from '../../../AbstractElements';
import config from '../../../config';
import licenseService from '../../../Services/licenseService';

const authHeader = () => {
    const token = localStorage.getItem('sessiontoken');
    return { headers: { Authorization: `${token}` } };
};

const CreatePOForm = ({ onCreated }) => {
    const { t } = useTranslation();
    const [properties, setProperties] = useState([]);
    const [poNumber, setPoNumber] = useState('');
    const [assetId, setAssetId] = useState('');
    const [quantity, setQuantity] = useState(10);
    const [issueDate, setIssueDate] = useState(() => new Date().toISOString().slice(0, 10));
    const [metadata, setMetadata] = useState('{}');
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        axios.get(`${config.hostname}/property`, authHeader())
            .then(res => setProperties(res.data || []))
            .catch(err => console.log(err));
    }, []);

    const submit = async (e) => {
        e.preventDefault();
        if (!poNumber || !assetId || !quantity || !issueDate) {
            toast.error(t('All fields except metadata are required'));
            return;
        }
        let parsedMeta = {};
        try {
            parsedMeta = metadata.trim() ? JSON.parse(metadata) : {};
        } catch (err) {
            toast.error(t('Metadata must be valid JSON'));
            return;
        }
        setSubmitting(true);
        try {
            const res = await licenseService.createPO({
                po_number: poNumber,
                po_property_id: assetId,
                po_quantity: Number(quantity),
                po_issue_date: issueDate,
                po_metadata: parsedMeta
            });
            toast.success(t('PO created. {{count}} licenses minted.', { count: res.data.pool_created }));
            setPoNumber('');
            setQuantity(10);
            setMetadata('{}');
            if (onCreated) onCreated();
        } catch (err) {
            const msg = err.response?.data?.message || err.message || t('Failed to create PO');
            toast.error(msg);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className='license-glass-card'>
            <div className='license-card-title'>{t('Create Purchase Order')}</div>
            <div className='license-card-sub mb-3'>
                {t('Mints N individual licenses bound to the selected asset. License IDs follow')} <code>[MallCode]-[PO#]-[Sequence]</code>.
            </div>
            <Form onSubmit={submit}>
                <Row>
                    <Col md='6'>
                        <FormGroup>
                            <Label>{t('PO Number')}</Label>
                            <Input value={poNumber} onChange={e => setPoNumber(e.target.value)} placeholder={t('PO-2026-Q2-001')} />
                        </FormGroup>
                    </Col>
                    <Col md='6'>
                        <FormGroup>
                            <Label>{t('Asset (Property)')}</Label>
                            <Input type='select' value={assetId} onChange={e => setAssetId(e.target.value)}>
                                <option value=''>{t('Select asset…')}</option>
                                {properties.map(p => (
                                    <option key={p._id} value={p._id}>
                                        {p.property_name} · {p.property_mall_code}
                                    </option>
                                ))}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md='4'>
                        <FormGroup>
                            <Label>{t('Quantity')}</Label>
                            <Input type='number' min='1' value={quantity} onChange={e => setQuantity(e.target.value)} />
                        </FormGroup>
                    </Col>
                    <Col md='4'>
                        <FormGroup>
                            <Label>{t('Issue Date')}</Label>
                            <Input type='date' value={issueDate} onChange={e => setIssueDate(e.target.value)} />
                        </FormGroup>
                    </Col>
                    <Col md='4'>
                        <FormGroup>
                            <Label>{t('Metadata (JSON)')}</Label>
                            <Input type='textarea' rows='1' value={metadata} onChange={e => setMetadata(e.target.value)} />
                        </FormGroup>
                    </Col>
                </Row>
                <Btn attrBtn={{ color: 'primary', type: 'submit', disabled: submitting }}>
                    {submitting ? t('Minting…') : t('Create PO & Mint Licenses')}
                </Btn>
            </Form>
        </div>
    );
};

export default CreatePOForm;
